// extracted by mini-css-extract-plugin
export default {"container":"footer_container__7mPGt","innerContainer":"footer_innerContainer__ij5dR","col":"footer_col__2aopr","hidden":"footer_hidden__UYAdP","copyright":"footer_copyright__GS-7g"};